import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

export const ExitGroupDialog = ({ open, onClose, onConfirm }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    PaperProps={{ sx: { borderRadius: "12px" } }}
  >
    <DialogTitle sx={{ pb: 1, borderBottom: "1px solid #e0e0e0" }}>
      <Typography variant="h6" sx={{ fontWeight: 600 }}>exit group</Typography>
    </DialogTitle>
    <DialogContent sx={{ pt: 3 }}>
      <Typography variant="body1" color="text.secondary">
        are you sure you want to exit this group? you will no longer receive messages from this group.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ p: 2, justifyContent: "flex-end", gap: 1 }}>
      <Button
        onClick={onClose}
        variant="contained"
        sx={{ textTransform: "lowercase", borderRadius: "8px", px: 3, py: 1 }}
      >
        cancel
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        color="error"
        sx={{ textTransform: "lowercase", borderRadius: "8px", px: 3, py: 1, fontWeight: 600 }}
      >
        exit group
      </Button>
    </DialogActions>
  </Dialog>
);

export const ClearChatDialog = ({ open, onClose, onConfirm }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    PaperProps={{ sx: { borderRadius: "12px" } }}
  >
    <DialogTitle sx={{ pb: 1, borderBottom: "1px solid #e0e0e0" }}>
      <Typography variant="h6" sx={{ fontWeight: 600 }}>clear chat</Typography>
    </DialogTitle>
    <DialogContent sx={{ pt: 3 }}>
      <Typography variant="body1" color="text.secondary">
        are you sure you want to clear this chat?
      </Typography>
    </DialogContent>
    <DialogActions sx={{ p: 2, justifyContent: "flex-end", gap: 1 }}>
      <Button
        onClick={onClose}
        variant="contained"
        sx={{ textTransform: "lowercase", borderRadius: "8px", px: 3, py: 1 }}
      >
        cancel
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        color="warning"
        sx={{ textTransform: "lowercase", borderRadius: "8px", px: 3, py: 1, fontWeight: 600 }}
      >
        clear chat
      </Button>
    </DialogActions>
  </Dialog>
);
